{
  "page": {
    "title": "Mailing",
    "tabs": {
      "contacts": "Contacts",
      "lists": "Mailing Lists",
      "emails": "Emails"
    },
    "search": "Search",
    "searchPlaceholder": "Name or email…",
    "tag": "Tag",
    "allTags": "All tags",
    "newContact": "New contact",
    "emptyHeading": "No contacts",
    "emptyManage": "Add external (non-student) contacts to email alongside students.",
    "emptyPlain": "No contacts match.",
    "subscribed": "Subscribed",
    "unsubscribed": "Unsubscribed",
    "editContact": "Edit contact",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "phoneOptional": "Phone (optional)",
    "relationshipOptional": "Relationship (optional)",
    "relationshipPlaceholder": "e.g. Parent of …",
    "tags": "Tags",
    "subscribedToggle": "Subscribed to emails",
    "saveContact": "Save contact",
    "edit": "Edit",
    "delete": "Delete"
  },
  "columns": {
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "relationship": "Relationship",
    "tags": "Tags",
    "subscribed": "Subscribed",
    "type": "Type",
    "status": "Status"
  },
  "lists": {
    "newList": "New list",
    "byAuthor": "by {name}",
    "noSavedLists": "No saved lists yet.",
    "editList": "Edit list",
    "listName": "List name",
    "listNamePlaceholder": "e.g. Active beginners",
    "audience": "Audience",
    "audienceStudents": "Students only",
    "audienceContacts": "Contacts only",
    "audienceBoth": "Students + contacts",
    "studentStatus": "Student status",
    "any": "Any",
    "active": "Active",
    "inactive": "Inactive",
    "enrolledClass": "Enrolled in class",
    "anyClass": "Any class",
    "danceType": "Dance type",
    "anyDanceType": "Any dance type",
    "level": "Level",
    "anyLevel": "Any level",
    "paymentStatus": "Payment status",
    "paidUp": "Paid up",
    "hasOverdue": "Has overdue",
    "hasPending": "Has pending",
    "eventParticipant": "Event participant",
    "anyEvent": "Any event",
    "minAge": "Min age",
    "minAgePlaceholder": "e.g. 5",
    "maxAge": "Max age",
    "maxAgePlaceholder": "e.g. 18",
    "contactsTagsOnly": "Contacts are matched by tags only — student filters don’t apply.",
    "tagsLabelBoth": "Tags (students + contacts) — matches any selected",
    "tagsLabelContacts": "Tags (contacts) — matches any selected",
    "saveChanges": "Save changes",
    "saveList": "Save list",
    "deleteList": "Delete list",
    "resolving": "Resolving…",
    "recipientCount_one": "{count} recipient",
    "recipientCount_other": "{count} recipients",
    "canBeEmailed": "{count} can be emailed",
    "showingFirst": " · showing first {count}",
    "noRecipients": "No recipients match these filters.",
    "unsubscribedPill": "unsubscribed"
  },
  "emails": {
    "newEmail": "New email",
    "noSubject": "(no subject)",
    "sentCount": "{count} sent",
    "noList": "no list",
    "noEmails": "No emails yet.",
    "editDraft": "Edit draft",
    "sentEmail": "Sent email",
    "to": "To",
    "listFallback": "list",
    "recipientCount_one": "{count} recipient",
    "recipientCount_other": "{count} recipients",
    "cloneAsDraft": "Clone as draft",
    "recipients": "Recipients",
    "showSendError": "Show send error",
    "noErrorDetailShort": "No error detail was recorded",
    "sendError": "Send error",
    "deliveryFailedPre": "Delivery to",
    "deliveryFailedPost": "failed with:",
    "noErrorDetailFailure": "No error detail was recorded for this failure.",
    "close": "Close"
  },
  "compose": {
    "newEmail": "New email",
    "subject": "Subject",
    "sendToList": "Send to mailing list",
    "chooseList": "Choose a list…",
    "noListsYet": "No mailing lists yet — create one in the Mailing Lists tab first.",
    "message": "Message",
    "footerNote": "Sent from your school’s configured email address. An unsubscribe link is added automatically.",
    "saveDraft": "Save draft",
    "preview": "Preview",
    "sendTest": "Send test",
    "sendEllipsis": "Send…",
    "emailPreview": "Email preview",
    "fromLine": "From your school’s configured email · recipients can reply",
    "emptyMessage": "_(empty message)_",
    "unsubLong": "You received this email from your school. If you no longer wish to receive these emails,",
    "unsubShort": "You received this email from your school.",
    "unsubLink": "unsubscribe here",
    "sendEmail": "Send email",
    "mailingList": "Mailing list",
    "counting": "Counting…",
    "emailable_one": "{count} emailable recipient",
    "emailable_other": "{count} emailable recipients",
    "matchedUnsub": "· {total} matched, {count} unsubscribed",
    "messagePreview": "Message preview",
    "collapse": "Collapse",
    "expand": "Expand",
    "sendTestToMe": "Send test to me",
    "sendTestTitle": "Send test to {email}",
    "yourEmail": "your email",
    "sendToCount": "Send to {count}",
    "send": "Send"
  },
  "status": {
    "draft": "Draft",
    "sent": "Sent",
    "pending": "Pending",
    "failed": "Failed",
    "scheduled": "Scheduled"
  },
  "toast": {
    "contactNameRequired": "First and last name are required",
    "contactEmailRequired": "Email is required",
    "contactSaved": "Contact saved",
    "contactSaveFailed": "Failed to save contact",
    "contactDeleted": "Contact deleted",
    "confirmDeleteContact": "Delete contact \"{name}\"?",
    "listNameRequired": "Give the list a name",
    "listSaved": "Mailing list saved",
    "listSaveFailed": "Failed to save",
    "listDeleted": "Mailing list deleted",
    "confirmDeleteList": "Delete mailing list \"{name}\"?",
    "draftSubjectRequired": "Give the email a subject",
    "draftSaved": "Draft saved",
    "draftSaveFailed": "Failed to save draft",
    "sendSubjectRequired": "Add a subject before sending",
    "bodyEmpty": "The email body is empty",
    "listRequired": "Choose a mailing list to send to",
    "emailSent": "Email sent",
    "sendFailed": "Failed to send",
    "testSubjectRequired": "Add a subject before sending a test",
    "testValidated": "Test validated (sandbox — not delivered); would go to {email}",
    "testSent": "Test email sent to {email}",
    "testFailed": "Failed to send the test",
    "cloned": "Cloned as a new draft",
    "confirmDeleteEmail": "Delete this email?",
    "emailDeleted": "Email deleted"
  }
}
